<template>
  <div class="user-cards-container mb-4">
    <!-- {{ props.days }} -->
    <div class="user-cards">
      <v-tooltip
        location="top"
        :text="user.name"
        v-for="user in users"
        :key="user.id"
      >
        <template v-slot:activator="{ props }">
          <v-card
            v-bind="props"
            :class="{ 'border-primary': selectedUserId === user.id }"
            class="user-card cursor-pointer"
            @click="$emit('user-selected', user)"
          >
            <v-card-text class="pa-2">
              <div class="d-flex align-center">
                <v-avatar
                  :style="{
                    backgroundColor: user.color,
                    color: isColorDark(user.color) ? 'white' : 'black'
                  }"
                  class="mr-2"
                  size="24"
                >
                  {{ user.iniciales }}
                </v-avatar>
                <div class="text-caption">
                  <span
                    v-for="(count, index) in getSobCountsByWeek(user)"
                    :key="index"
                  >
                    {{ count }}
                    <span v-if="index < 3">| </span>
                  </span>
                </div>
                <v-btn
                  v-if="selectedUserId === user.id"
                  icon="mdi-beach"
                  size="small"
                  color="info"
                  class="ml-2"
                  @click.stop="$emit('show-vacaciones')"
                  variant="text"
                ></v-btn>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-tooltip>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { isColorDark } from '@/utils/helpers'
// import { defineProps, defineEmits } from 'vue'
// import { getISOWeekNumber } from '@/utils/helpers'

const props = defineProps({
  users: {
    type: Array,
    required: true
  },
  selectedUserId: {
    type: Number,
    default: null
  },
  schedules: {
    type: Object,
    required: true
  },
  days: {
    type: Array,
    required: true
  }
})

// const emit = defineEmits(['user-selected', 'show-vacaciones'])

const getDateKey = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

const getSobCountsByWeek = (user) => {
  const counts = [0, 0, 0, 0] // Una entrada por cada semana mostrada

  if (!props.days || !props.schedules || props.days.length === 0) return counts

  // Agrupamos los días por semanas usando el índice
  props.days.forEach((day, dayIndex) => {
    // Calculamos a qué semana pertenece este día (0-3)
    const weekIndex = Math.floor(dayIndex / 7)

    if (weekIndex < 4) {
      // Solo procesamos las primeras 4 semanas
      const dayKey = getDateKey(day)
      const daySchedule = props.schedules[dayKey]

      // Verificar si el usuario está en 'sob' ese día
      if (daySchedule?.sob?.some((u) => u.id === user.id)) {
        counts[weekIndex]++
      }
    }
  })

  return counts
}
</script>

<style scoped>
.user-cards-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.user-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  justify-content: center;
}

.user-card {
  flex: 0 0 auto;
  min-width: 100px;
}

.border-primary {
  border: 2px solid rgb(var(--v-theme-primary));
}

.cursor-pointer {
  cursor: pointer;
}

.v-card-text {
  padding: 8px !important;
}

.v-avatar {
  width: 30px !important;
  height: 30px !important;
  font-size: 0.7rem !important;
}

.text-caption {
  font-size: 0.875rem;
}
</style>
